import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getMessaging, isSupported } from "firebase/messaging";

// PRODUCTION
export const extra = {
    firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    firebaseAuthDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    firebaseStorageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    firebaseMessagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID,
    "eas": {
        "projectId": process.env.REACT_APP_EAS_PROJECT_ID
    },
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    webClientId: process.env.REACT_APP_WEB_CLIENT_ID,
}

// DEVELOPMENT
// export const extra = {
//     firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//     firebaseAuthDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//     firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//     firebaseStorageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//     firebaseMessagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//     firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID,
//     databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
//     webClientId: process.env.REACT_APP_WEB_CLIENT_ID,
// }

const firebaseConfig = {
    apiKey: extra?.firebaseApiKey,
    authDomain: extra?.firebaseAuthDomain,
    projectId: extra?.firebaseProjectId,
    storageBucket: extra?.firebaseStorageBucket,
    messagingSenderId: extra?.firebaseMessagingSenderId,
    appId: extra?.firebaseAppId,
    databaseURL: extra?.databaseURL,
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const functions = getFunctions(app);

let messaging: ReturnType<typeof getMessaging> | null = null;
isSupported().then((supported) => {
    if (supported) {
        messaging = getMessaging(app);
    }
}).catch((err) => console.log('Firebase messaging not supported', err));

export { db, storage, auth, functions, messaging };
